// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { TransferInstruction } from '@daml.js/splice-api-token-transfer-instruction/lib/Splice/Api/Token/TransferInstructionV1';
import { ContractId } from '@daml/types';
import { RowNew } from '../../../../components/Table/types';
import { useAcceptTransferInstruction } from './useAcceptTransferInstruction';
import { useRejectTransferInstruction } from './useRejectTransferInstruction';
import { useWithdrawTransferInstruction } from './useWithdrawTransferInstruction';

export const useGetTransferChoices = (onSuccess: () => void, selectedRow?: RowNew) => {
  // transfer instructions
  const acceptTransferInstruction = useAcceptTransferInstruction();
  const withdrawTransferInstruction = useWithdrawTransferInstruction();
  const rejectTransferInstruction = useRejectTransferInstruction();

  const onAccept = async () => {
    if (!selectedRow) {
      throw new Error('Now row');
    }
    if (selectedRow.isInterface) {
      await acceptTransferInstruction({
        registrar: selectedRow.registrar,
        transferCid: selectedRow.contractId as ContractId<TransferInstruction>,
      });
    }
    onSuccess?.();
  };
  const onCancel = async () => {
    if (!selectedRow) {
      throw new Error('No row');
    }
    if (selectedRow.isInterface) {
      await withdrawTransferInstruction({
        registrar: selectedRow.registrar,
        transferCid: selectedRow.contractId as ContractId<TransferInstruction>,
      });
    }
    onSuccess?.();
  };
  const onReject = async (reason: string) => {
    if (!selectedRow) {
      throw new Error('No row');
    }
    if (selectedRow.isInterface) {
      await rejectTransferInstruction({
        registrar: selectedRow.registrar,
        transferCid: selectedRow.contractId as ContractId<TransferInstruction>,
        reason,
      });
    }
    onSuccess?.();
  };
  return {
    onAccept,
    onReject,
    onCancel,
  };
};
